import { Component } from 'react';
import { Form, Button, InputGroup } from 'react-bootstrap';

export default class PasswordField extends Component {
    
    state = {    
        showPassword: false
    }

    togglePasswordVisibility = () => {
        this.setState({
            showPassword: this.state.showPassword === true ? false: true
        })
    }

    render() {   
        let formControl =  
                <InputGroup>
                <Form.Control ref={this.props.ref} autoComplete={this.props.autoComplete ? this.props.autoComplete : 'on' } style={this.props.style} required type={this.state.showPassword === true ? 'text' : 'password'} minLength={this.props.minLength} maxLength={this.props.maxLength} disabled={this.props.disabled} onChange={this.props.onChange} onBlur={this.props.onBlur} value={this.props.value}/>
                <Button variant="outline-secondary" onClick={this.togglePasswordVisibility} >   {this.state.showPassword ? 'Hide' : 'Show'}   </Button></InputGroup> 
        return (
            <>{formControl}</>
        )
    }
}